import React, {FC} from 'react'

const DemosToggleDrawer: FC = () => <div></div>

export {DemosToggleDrawer}
